function BBCollectionModel($q, BBModel, BaseModel) {
    'ngInject';

    class BBCollection extends BaseModel {

        getNextPage(params) {

            const deferred = $q.defer();

            this.$get('next', params).then(collection => deferred.resolve(new BBModel.BBCollection(collection))
                , () => deferred.reject());

            return deferred.promise;
        }
    }

    return BBCollection;
}

angular
    .module('BB')
    .service('BBCollectionModel', BBCollectionModel);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_models/bb_collection_model.service.js